import { ACTIONS } from '_redux/actions';

const initialState = {
  content: {
    mediaItems: [],
  },
  contentLoading: true,
};

export default function media(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.MEDIA.FETCH_MEDIA: {
      return {
        ...state,
        contentLoading: true,
      };
    }

    case ACTIONS.MEDIA.FETCH_MEDIA_SUCCESS: {
      let items = [];

      if (state.content.mediaItems.length > 0 && action.payload.params.pageNumber > 0) {
        items = [...state.content.mediaItems, ...action.payload.data.submissionItems];
      } else {
        items = [...action.payload.data.submissionItems];
      }

      return {
        ...state,
        content: {
          mediaItems: items,
          canLoadMore: action.payload.data.canLoadMore,
        },
        contentLoading: false,
      };
    }

    default:
      return state;
  }
}
